import { HEXcolor, NameFirmType, SelectedBrushType } from '../types'

export enum FirmIndexes {
  CURAPROX = 0,
  TEPE = 1,
  INTERPROX = 2,
  CURASEPT = 3,
}

type Color = null | HEXcolor

export type FirmWithAutoFillColors = {
  title: NameFirmType
  index: FirmIndexes
  titleGroups: string[]
  content: {
    [key: HEXcolor]: [Color, Color, Color, Color]
  }
}

export type ListColorByNameFirm = {
  [key in NameFirmType]: SelectedBrushType[][]
}

export const CURAPROX: FirmWithAutoFillColors = {
  title: 'Curaprox',
  index: FirmIndexes.CURAPROX,
  titleGroups: ['PRIME', 'PERIO'],
  content: {
    '#00ABA6': [null, '#FF517B', '#FF517B', '#DDBCBC'],
    '#DC0A28': [null, '#FB9B00', '#FB9B00', '#F4B3CF'],
    '#D75296': [null, '#F93315', '#15f9d3ff', '#FDAB59'],
    '#F7E55B': [null, '#04A2CF', '#f40606ff', '#B7D48E'],
    '#55AF4E': [null, '#FEE800', '#F2FE5C', '#A2BDCE'],
  },
}

export const TEPE: FirmWithAutoFillColors = {
  title: 'TePe',
  index: FirmIndexes.TEPE,
  titleGroups: ['ЖЕСТКОСТЬ'],
  content: {
    '#FF517B': ['#00ABA6', null, '#FF517B', '#DDBCBC'],
    '#FB9B00': ['#DC0A28', null, '#FB9B00', '#F4B3CF'],
    '#F93315': ['#D75296', null, '#15f9d3ff', '#FDAB59'],
    '#04A2CF': ['#F7E55B', null, '#f40606ff', '#B7D48E'],
    '#FEE800': ['#55AF4E', null, '#F2FE5C', '#A2BDCE'],
    '#02B600': [null, null, '#068FF4', null],
  },
}

export const INTERPROX: FirmWithAutoFillColors = {
  title: 'Interprox',
  index: FirmIndexes.INTERPROX,
  titleGroups: ['PLUS'],
  content: {
    '#FF517B': ['#00ABA6', '#FF517B', null, '#DDBCBC'],
    '#FB9B00': ['#DC0A28', '#FB9B00', null, '#F4B3CF'],
    '#15f9d3ff': ['#D75296', '#F93315', null, '#FDAB59'],
    '#f40606ff': ['#F7E55B', '#04A2CF', null, '#B7D48E'],
    '#F2FE5C': ['#55AF4E', '#FEE800', null, '#A2BDCE'],
    '#068FF4': [null, '#02B600', null, null],
  },
}

export const CURASEPT: FirmWithAutoFillColors = {
  title: 'Curasept',
  index: FirmIndexes.CURASEPT,
  titleGroups: ['TREATMENT', 'PREVENTION'],
  content: {
    '#DDBCBC': ['#00ABA6', '#FF517B', '#FF517B', null],
    '#F4B3CF': ['#DC0A28', '#FB9B00', '#FB9B00', null],
    '#FDAB59': ['#D75296', '#F93315', '#15f9d3ff', null],
    '#B7D48E': ['#F7E55B', '#04A2CF', '#f40606ff', null],
    '#A2BDCE': ['#55AF4E', '#FEE800', '#F2FE5C', null],
  },
}

export const TEPE_COLOR_LIST: SelectedBrushType[] = [
  {
    color: '#FF517B',
    colorName: '0',
    type: 1,
  },
  {
    color: '#FB9B00',
    colorName: '1',
    type: 1,
  },
  {
    color: '#F93315',
    colorName: '2',
    type: 1,
  },
  {
    color: '#04A2CF',
    colorName: '3',
    type: 1,
  },
  {
    color: '#FEE800',
    colorName: '4',
    type: 1,
  },
  {
    color: '#02B600',
    colorName: '5',
    type: 1,
  },
  {
    color: '#CB66AC',
    colorName: '6',
    type: 1,
  },
  {
    color: '#B2AEA5',
    colorName: '7',
    type: 1,
  },
  {
    color: '#040001',
    colorName: '8',
    type: 1,
  },
]

export const CURAPROX_COLOR_LIST_LEFT: SelectedBrushType[] = [
  {
    color: '#00ABA6',
    colorName: '06',
    type: 1,
  },
  {
    color: '#DC0A28',
    colorName: '07',
    type: 1,
  },
  {
    color: '#D75296',
    colorName: '08',
    type: 1,
  },
  {
    color: '#F7E55B',
    colorName: '09',
    type: 1,
  },
  {
    color: '#55AF4E',
    colorName: '011',
    type: 1,
  },
]

export const CURAPROX_COLOR_LIST_RIGHT: SelectedBrushType[] = [
  {
    color: '#F67085',
    colorName: '405',
    type: 2,
  },
  {
    color: '#DD8DC3',
    colorName: '406',
    type: 2,
  },
  {
    color: '#963DAE',
    colorName: '408',
    type: 2,
  },
  {
    color: '#039ABD',
    colorName: '410',
    type: 2,
  },
]

export const INTERPROX_COLOR_LIST: SelectedBrushType[] = [
  {
    color: '#FF517B',
    colorName: 'nano',
    type: 1,
  },
  {
    color: '#FB9B00',
    colorName: 'super micro',
    type: 1,
  },
  {
    color: '#15f9d3ff',
    colorName: 'micro',
    type: 1,
  },
  {
    color: '#F2FE5C',
    colorName: 'mini',
    type: 1,
  },
  {
    color: '#068FF4',
    colorName: 'conical',
    type: 1,
  },
  {
    color: '#f40606ff',
    colorName: 'mini conical',
    type: 1,
  },
  {
    color: '#9910FC',
    colorName: 'maxi',
    type: 1,
  },
]

export const CURASEPT_COLOR_LIST_LEFT: SelectedBrushType[] = [
  {
    color: '#CE5099',
    colorName: '10',
    type: 1,
  },
  {
    color: '#EC1C1C',
    colorName: '12',
    type: 1,
  },

  {
    color: '#F3701B',
    colorName: '14',
    type: 1,
  },
  {
    color: '#FEDF12',
    colorName: '17',
    type: 1,
  },
  {
    color: '#4079C4',
    colorName: '20',
    type: 1,
  },
  {
    color: '#785CA6',
    colorName: '21',
    type: 1,
  },
  {
    color: '#A1A5A8',
    colorName: '27',
    type: 1,
  },
  {
    color: '#64696C',
    colorName: '33',
    type: 1,
  },
]

export const CURASEPT_COLOR_LIST_RIGHT: SelectedBrushType[] = [
  {
    color: '#DDBCBC',
    colorName: '06',
    type: 2,
  },
  {
    color: '#F4B3CF',
    colorName: '07',
    type: 2,
  },
  {
    color: '#FDAB59',
    colorName: '08',
    type: 2,
  },
  {
    color: '#B7D48E',
    colorName: '09',
    type: 2,
  },
  {
    color: '#A2BDCE',
    colorName: '11',
    type: 2,
  },
]

export const LIST_COLORS_BY_NAME_FIRM: ListColorByNameFirm = {
  TePe: [TEPE_COLOR_LIST],
  Curaprox: [CURAPROX_COLOR_LIST_LEFT, CURAPROX_COLOR_LIST_RIGHT],
  Interprox: [INTERPROX_COLOR_LIST],
  Curasept: [CURASEPT_COLOR_LIST_LEFT, CURASEPT_COLOR_LIST_RIGHT],
}
